'use client';
import Badge from "./Badge.js";
export default Badge;